import React from 'react'
import Payout from '../../features/trainer/Payout'

const TrainerPayoutPage = () => {
  return <Payout/>
}

export default TrainerPayoutPage